import {
  FETCH_NAV_ATHLETES_START,
  FETCH_NAV_ATHLETES_FULFILLED,
  FETCH_NAV_ATHLETES_REJECTED,
  FETCH_NAV_ATHLETE_ASSIGNMENTS_START,
  FETCH_NAV_ATHLETE_ASSIGNMENTS_FULFILLED,
  FETCH_NAV_ATHLETE_ASSIGNMENTS_REJECTED,
  FETCH_NAV_CALENDARS_START,
  FETCH_NAV_CALENDARS_FULFILLED,
  FETCH_NAV_CALENDARS_REJECTED,
  FETCH_NAV_CALENDAR_ITEMS_START,
  FETCH_NAV_CALENDAR_ITEMS_FULFILLED,
  FETCH_NAV_CALENDAR_ITEMS_REJECTED,
  FETCH_NAV_CALENDAR_PREVIEW_START,
  FETCH_NAV_CALENDAR_PREVIEW_FULFILLED,
  FETCH_NAV_CALENDAR_PREVIEW_REJECTED,
  FETCH_NAV_PROGRAMS_START,
  FETCH_NAV_PROGRAMS_FULFILLED,
  FETCH_NAV_PROGRAMS_REJECTED,
  FETCH_NAV_PROGRAM_ITEMS_START,
  FETCH_NAV_PROGRAM_ITEMS_FULFILLED,
  FETCH_NAV_PROGRAM_ITEMS_REJECTED,
  FETCH_NAV_PROGRAM_DAY_ONE_START,
  FETCH_NAV_PROGRAM_DAY_ONE_FULFILLED,
  FETCH_NAV_PROGRAM_DAY_ONE_REJECTED,
  FETCH_NAV_PROGRAM_PREVIEW_START,
  FETCH_NAV_PROGRAM_PREVIEW_FULFILLED,
  FETCH_NAV_PROGRAM_PREVIEW_REJECTED,
  FETCH_NAV_WORKOUT_RESULTS_START,
  FETCH_NAV_WORKOUT_RESULTS_FULFILLED,
  FETCH_NAV_WORKOUT_RESULTS_REJECTED,
  FETCH_NAV_DAY_WORKOUT_ITEMS_START,
  FETCH_NAV_DAY_WORKOUT_ITEMS_FULFILLED,
  FETCH_NAV_DAY_WORKOUT_ITEMS_REJECTED,
} from './actionTypes';

const initialState = {
  athletes: [],
  athletesError: null,
  athleteAssignments: null,
  athleteAssignmentsError: null,
  activeCalendars: [],
  activePrograms: [],
  inactiveCalendars: [],
  calendarsError: null,
  calendarPreview: [],
  calendarPreviewError: null,
  calendarItems: null,
  calendarItemsError: null,
  calendarWorkoutDate: null,
  currentWorkout: { workoutItems: [] },
  dayWorkoutItemsError: null,
  programs: [],
  programsError: null,
  programItems: null,
  programItemsError: null,
  programPreviewItems: null,
  programPreviewDays: [],
  programPreviewInitialDayIndex: 0,
  programPreviewWeekNumber: null,
  programPreviewDayInWeek: null,
  programPreviewError: null,
  programDayOneError: null,
  workoutResults: null,
  workoutResultsError: null,
};

// eslint-disable-next-line default-param-last
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_NAV_ATHLETES_START:
      return {
        ...state,
        athletesError: null,
      };
    case FETCH_NAV_ATHLETES_FULFILLED:
      return {
        ...state,
        athletes: action.payload,
        athletesError: null,
      };
    case FETCH_NAV_ATHLETES_REJECTED:
      return {
        ...state,
        athletesError: action.payload,
      };
    case FETCH_NAV_ATHLETE_ASSIGNMENTS_START:
      return {
        ...state,
        athleteAssignmentsError: null,
      };
    case FETCH_NAV_ATHLETE_ASSIGNMENTS_FULFILLED:
      return {
        ...state,
        athleteAssignments: action.payload,
        athleteAssignmentsError: null,
      };
    case FETCH_NAV_ATHLETE_ASSIGNMENTS_REJECTED:
      return {
        ...state,
        athleteAssignmentsError: action.payload,
      };
    case FETCH_NAV_CALENDARS_START:
      return {
        ...state,
        calendarsError: null,
      };
    case FETCH_NAV_CALENDARS_FULFILLED:
      return {
        ...state,
        activeCalendars: action.payload.activeCalendars || [],
        inactiveCalendars: action.payload.inactiveCalendars || [],
        calendarsError: null,
      };
    case FETCH_NAV_CALENDARS_REJECTED:
      return {
        ...state,
        calendarsError: action.payload,
      };
    case FETCH_NAV_CALENDAR_ITEMS_START:
      return {
        ...state,
        calendarItems: null,
        calendarWorkoutDate: null,
        calendarItemsError: null,
      };
    case FETCH_NAV_CALENDAR_ITEMS_FULFILLED:
      return {
        ...state,
        calendarItems: action.payload.workoutItems,
        calendarWorkoutDate: action.payload.workoutDate,
        calendarItemsError: null,
      };
    case FETCH_NAV_CALENDAR_ITEMS_REJECTED:
      return {
        ...state,
        calendarItemsError: action.payload,
      };
    case FETCH_NAV_CALENDAR_PREVIEW_START:
      return {
        ...state,
        calendarPreview: [],
        calendarPreviewError: null,
      };
    case FETCH_NAV_CALENDAR_PREVIEW_FULFILLED: {
      return {
        ...state,
        calendarPreview: action.payload || [],
        calendarPreviewError: null,
      };
    }
    case FETCH_NAV_CALENDAR_PREVIEW_REJECTED: {
      return {
        ...state,
        calendarPreview: [],
        calendarPreviewError: action.payload,
      };
    }
    case FETCH_NAV_PROGRAMS_START:
      return {
        ...state,
        programsError: null,
      };
    case FETCH_NAV_PROGRAMS_FULFILLED:
      return {
        ...state,
        programs: action.payload || [],
        programsError: null,
      };
    case FETCH_NAV_PROGRAMS_REJECTED:
      return {
        ...state,
        programsError: action.payload,
      };
    case FETCH_NAV_PROGRAM_ITEMS_START:
      return {
        ...state,
        programItemsError: null,
      };
    case FETCH_NAV_PROGRAM_ITEMS_FULFILLED:
      return {
        ...state,
        programItems: action.payload,
        programItemsError: null,
      };
    case FETCH_NAV_PROGRAM_ITEMS_REJECTED:
      return {
        ...state,
        programItemsError: action.payload,
      };
    case FETCH_NAV_PROGRAM_DAY_ONE_START:
      return {
        ...state,
        activePrograms: [],
        currentWorkout: { workoutItems: [] },
        programDayOneError: null,
      };
    case FETCH_NAV_PROGRAM_DAY_ONE_FULFILLED: {
      const data = action.payload?.data || {};
      const program = action.payload?.program || null;
      return {
        ...state,
        activePrograms: action.payload.data || [],
        currentWorkout: {
          ...data,
          assignedDayBasedProgramsData: program
            ? [program]
            : (data.assignedDayBasedProgramsData
              ?? state.currentWorkout.assignedDayBasedProgramsData ?? []),
        },
        programDayOneError: null,
      };
    }
    case FETCH_NAV_PROGRAM_DAY_ONE_REJECTED: {
      return {
        ...state,
        activePrograms: [],
        currentWorkout: { workoutItems: [] },
        programDayOneError: action.payload,
      };
    }
    case FETCH_NAV_PROGRAM_PREVIEW_START:
      return {
        ...state,
        programPreviewItems: null,
        programPreviewDays: [],
        programPreviewInitialDayIndex: 0,
        programPreviewWeekNumber: null,
        programPreviewDayInWeek: null,
        programPreviewError: null,
      };
    case FETCH_NAV_PROGRAM_PREVIEW_FULFILLED:
      return {
        ...state,
        programPreviewItems:
          action.payload.programDays?.[action.payload.initialDayIndex]?.exercises || [],
        programPreviewDays: action.payload.programDays || [],
        programPreviewInitialDayIndex: action.payload.initialDayIndex || 0,
        programPreviewWeekNumber: null,
        programPreviewDayInWeek: null,
        programPreviewError: null,
      };
    case FETCH_NAV_PROGRAM_PREVIEW_REJECTED:
      return {
        ...state,
        programPreviewError: action.payload,
      };
    case FETCH_NAV_WORKOUT_RESULTS_START:
      return {
        ...state,
        workoutResultsError: null,
      };
    case FETCH_NAV_WORKOUT_RESULTS_FULFILLED:
      return {
        ...state,
        workoutResults: action.payload,
        workoutResultsError: null,
      };
    case FETCH_NAV_WORKOUT_RESULTS_REJECTED:
      return {
        ...state,
        workoutResultsError: action.payload,
      };
    case FETCH_NAV_DAY_WORKOUT_ITEMS_START:
      return {
        ...state,
        currentWorkout: { workoutItems: [] },
        dayWorkoutItemsError: null,
      };
    case FETCH_NAV_DAY_WORKOUT_ITEMS_FULFILLED: {
      return {
        ...state,
        currentWorkout: action.payload.data,
        dayWorkoutItemsError: null,
      };
    }
    case FETCH_NAV_DAY_WORKOUT_ITEMS_REJECTED: {
      return {
        ...state,
        currentWorkout: { workoutItems: [] },
        dayWorkoutItemsError: action.payload,
      };
    }
    default:
      return state;
  }
}
